import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

const FAILURE = /\b(fail|failed|could not|couldn't|error|unable|cannot|missing)\b/i;

/** Transient confirmation or failure message. Failures stay until dismissed. */
const Message = ({
  message,
  setMessage,
}: {
  message: string | boolean;
  setMessage: (next: string | boolean) => void;
}) => {
  const text = typeof message === "string" ? message : "";
  const failed = FAILURE.test(text);
  const close = (_e?: unknown, reason?: string) => {
    if (reason === "clickaway") return;
    setMessage(false);
  };

  return (
    <Snackbar
      open={Boolean(message)}
      onClose={close}
      autoHideDuration={failed ? null : 5000}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ bottom: { xs: "calc(76px + env(safe-area-inset-bottom, 0px))", md: 24 } }}
    >
      <Alert severity={failed ? "error" : "success"} variant="filled" onClose={close} sx={{ width: "100%" }}>
        {text}
      </Alert>
    </Snackbar>
  );
};

export default Message;
